// SectionForm — rendert één sectie (titel + alle items).
// Krijgt getItem/setItem van useSurvey om state in sync te houden.

import React from 'react';
import { Card, CardContent, Typography, Stack, Divider } from '@mui/material';
import ItemInput from './ItemInput.jsx';
import { variantKey } from '../variants.js';

export default function SectionForm({
    section,
    clusterId,
    getItem,
    setItem,
    projectId,
    disabled,
    allSurveyData,
    onAddToRegister,
    riskRegister,
    variant = 1,
}) {
    const sectionKey = variantKey(section.id, variant);
    return (
        <Card variant="outlined" sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant="h4" component="h2" sx={{ mb: 2 }}>
                    {section.title}
                </Typography>
                <Divider sx={{ mb: 1 }} />
                <Stack divider={<Divider flexItem />}>
                    {section.items.map(item => (
                        <ItemInput
                            key={`${item.id}@${variant}`}
                            item={item}
                            uploadItemId={variantKey(item.id, variant)}
                            value={getItem(clusterId, sectionKey, item.id)}
                            onChange={(val) => setItem(clusterId, sectionKey, item.id, val)}
                            onFillSiblings={(obj) => {
                                for (const [sibId, sibVal] of Object.entries(obj || {})) {
                                    setItem(clusterId, sectionKey, sibId, sibVal);
                                }
                            }}
                            projectId={projectId}
                            disabled={disabled}
                            allSurveyData={allSurveyData}
                            onAddToRegister={onAddToRegister}
                            inRegister={Boolean(riskRegister?.some(r => r.item_id === variantKey(item.id, variant)))}
                        />
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
}
